function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 6.014 7 L 1.074 2.061 C 0.781 1.768 0.781 1.293 1.074 1 C 1.367 0.708 1.842 0.708 2.135 1 L 7.074 5.94 L 8.139 6.997 C 8.141 6.997 7.074 8.061 7.074 8.061 L 2.135 13 C 1.842 13.293 1.367 13.293 1.074 13 C 0.781 12.708 0.781 12.233 1.074 11.94 L 6.014 7 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0ae51f153bf55496ee58de26180c6a06.svg";
export { ForwardRef as ReactComponent };